import React from 'react';
import { Link } from 'react-router-dom';
import './ToolPage.css';

const tools = [
  {
    id: 'bg-remove',
    title: "Remove Background",
    desc: "Instantly isolate products from messy backgrounds. Perfect for creating clean catalog shots.",
    img: "/images/showcase/ToolsImages/BgRemoveTool.png",
    link: "/app/tool/background-remove",
    benefit: "Saves hours",
    badgeColor: "red"
  },
  {
    id: 'bg-replace',
    title: "Replace Background",
    desc: "Swap boring studio walls for high-end lifestyle settings or solid brand colors using AI.",
    img: "/images/showcase/ToolsImages/BgReplaceTool.png",
    link: "/app/tool/background-replacer",
    benefit: "No photoshoots",
    badgeColor: "brown"
  },
  {
    id: 'bg-blur',
    title: "Blur Background",
    desc: "Create professional depth-of-field (bokeh) effects to keep the focus strictly on your merchandise.",
    img: "/images/showcase/ToolsImages/BgBlurTool.png",
    link: "/app/tool/blur-background",
    benefit: "Premium look",
    badgeColor: "green"
  },
  {
    id: 'img-convert',
    title: "Image Converter",
    desc: "Seamlessly switch between formats (JPG, PNG, WebP) and optimize file size for SEO speed.",
    img: "/images/showcase/design-mountains.png", // Generic placeholder or specific tool img
    link: "/app/tool/image-converter",
    benefit: "Faster loading",
    badgeColor: "blue"
  }
];

export default function ToolPage() {
  return (
    <div className="tool-page-wrapper fade-in">
      
      {/* --- 1. HERO SECTION --- */}
      <header className="tool-hero-section">
        <div className="tool-hero-content">
          <div className="hero-text">
            <div className="hero-badge">Tools Suite v1.0</div>
            <h1>AI Image Tools for <br/> Ecommerce Sellers</h1>
            <p>
              Stop spending thousands on professional photography. Prepare, polish, and optimize your product images in seconds.
            </p>
            <div className="hero-actions">
              <button 
                className="btn-primary-hero"
                onClick={() => document.getElementById('tools-grid').scrollIntoView({ behavior: 'smooth' })}
              >
                Explore Tools <i className="bi bi-arrow-down"></i>
              </button>
            </div>
          </div>
          
          <div className="hero-visual">
            <div className="visual-card-stack">
               <img src="/images/showcase/ToolsImages/BgRemoveTool.png" alt="AI Tool Preview" className="stack-img main" />
               <img src="/images/showcase/ToolsImages/BgReplaceTool.png" alt="AI Tool Preview" className="stack-img sub" />
            </div>
          </div>
        </div>
      </header>

      {/* --- 2. VALUE PROPOSITION --- */}
      <section className="value-prop-section">
        <div className="value-grid">
          <div className="value-card red">
            <div className="icon-circle"><i className="bi bi-rocket-takeoff-fill"></i></div>
            <h3>Faster Time-to-Market</h3>
            <p>Go from a raw photo to a published product listing in under 60 seconds.</p>
          </div>
          <div className="value-card gold">
            <div className="icon-circle"><i className="bi bi-patch-check-fill"></i></div>
            <h3>Consistent Branding</h3>
            <p>Ensure all your product photos have the same clean background and high quality.</p>
          </div>
          <div className="value-card green">
            <div className="icon-circle"><i className="bi bi-magic"></i></div>
            <h3>Zero Skills Required</h3>
            <p>No Photoshop knowledge needed. Our AI handles the technical heavy lifting.</p>
          </div>
        </div>
      </section>

      {/* --- 3. TOOLS SHOWCASE (2x2 Grid) --- */}
      <section className="tools-showcase-section" id="tools-grid">
        <div className="section-header">
          <h2>Explore Our AI Suite</h2>
          <p>Everything you need to perfect your product images.</p>
        </div>

        <div className="premium-tools-grid">
          {tools.map((tool) => (
            <Link to={tool.link} key={tool.id} className="premium-tool-card">
              {/* Image Header */}
              <div className="card-image-area">
                <img src={tool.img} alt={tool.title} />
                <div className="card-overlay">
                  <span className="btn-view">Try Tool</span>
                </div>
              </div>

              {/* Content Body */}
              <div className="card-body">
                <div className="card-top">
                  <h3>{tool.title}</h3>
                  <span className={`benefit-pill ${tool.badgeColor}`}>
                    <i className="bi bi-check2"></i> {tool.benefit}
                  </span>
                </div>
                <p>{tool.desc}</p>
                <div className="card-footer">
                  <span className="link-text">Launch Tool <i className="bi bi-arrow-right"></i></span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* --- 4. HOW IT WORKS --- */}
      <section className="how-it-works-section">
        <div className="section-header">
          <h2>How It Works</h2>
          <p>Simple workflow. Professional results.</p>
        </div>
        
        <div className="steps-row">
          <div className="step-item">
            <div className="step-num">01</div>
            <h4>Upload Image</h4>
            <p>Drag and drop your raw product photo into any tool.</p>
          </div>
          <div className="step-connector"></div>
          <div className="step-item">
            <div className="step-num">02</div>
            <h4>AI Processing</h4>
            <p>Our engine analyzes and processes your pixels instantly.</p>
          </div>
          <div className="step-connector"></div>
          <div className="step-item">
            <div className="step-num">03</div>
            <h4>Download</h4>
            <p>Get your high-resolution, optimized result ready to sell.</p>
          </div>
        </div>
      </section>

      {/* --- 5. FINAL CTA --- */}
      <section className="tool-cta-section">
        <div className="cta-box">
          <h2>Ready to Transform Your Product Images?</h2>
          <p>Join thousands of sellers using FullMockup today.</p>
          <div className="cta-buttons">
            <Link to="/app/apparel" className="btn-primary-hero">
              Get Started for Free
            </Link>
            <span className="no-card-text"><i className="bi bi-shield-check"></i> No credit card required</span>
          </div>
        </div>
      </section>

    </div>
  );
}